import { render, staticRenderFns } from "./BannerAddForm.vue?vue&type=template&id=dc152420&"
import script from "./BannerAddForm.vue?vue&type=script&lang=ts&"
export * from "./BannerAddForm.vue?vue&type=script&lang=ts&"
import style0 from "./BannerAddForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports